import { defineStore } from 'pinia';
export var DashboardMenuState = /*#__PURE__*/function (DashboardMenuState) {
  DashboardMenuState["Dashboard"] = "dashboard";
  DashboardMenuState["Event"] = "event";
  DashboardMenuState["Profile"] = "profile";
  return DashboardMenuState;
}({});

// Values must match the `name` of the corresponding side-menu sub-item in
// layouts/organizer.vue - that is what highlights the active item.
export var DashboardMenuItem = /*#__PURE__*/function (DashboardMenuItem) {
  // dashboard
  DashboardMenuItem["MyEvents"] = "my-events";
  DashboardMenuItem["PdfTemplates"] = "pdfTemplates";
  DashboardMenuItem["Location"] = "location";
  DashboardMenuItem["Reporting"] = "reporting";
  DashboardMenuItem["Orders"] = "orders";
  DashboardMenuItem["TransactionRules"] = "transactionRules";
  DashboardMenuItem["Collections"] = "collections";
  DashboardMenuItem["AirDrops"] = "airDrops";
  DashboardMenuItem["Organizers"] = "organizers";
  DashboardMenuItem["Users"] = "users";
  DashboardMenuItem["ManageAccounts"] = "manage-accounts";
  DashboardMenuItem["OrganizerApplications"] = "organizer-applications";
  DashboardMenuItem["SendNotifications"] = "send-notifications";
  DashboardMenuItem["SendNewsletter"] = "send-newsletter";
  // event
  DashboardMenuItem["EventDetails"] = "eventDetails";
  DashboardMenuItem["Occurrences"] = "occurrences";
  DashboardMenuItem["TicketCategories"] = "ticketCategories";
  DashboardMenuItem["TicketNftMedia"] = "ticketNFTMedia";
  DashboardMenuItem["ExternalTickets"] = "externalTickets";
  DashboardMenuItem["PresaleCodes"] = "presaleCodes";
  DashboardMenuItem["Discounts"] = "discounts";
  DashboardMenuItem["SponsorPromotions"] = "sponsorPromotions";
  DashboardMenuItem["Sectors"] = "sectors";
  DashboardMenuItem["EntryTimeslots"] = "entryTimeslots";
  DashboardMenuItem["FloorplanDesigner"] = "floorplanDesigner";
  DashboardMenuItem["SeatManagement"] = "seatManagement";
  DashboardMenuItem["Questionnaires"] = "questionnaires";
  DashboardMenuItem["QuestionnaireAssignments"] = "questionnaireAssignments";
  DashboardMenuItem["SoldTickets"] = "soldTickets";
  DashboardMenuItem["SentTickets"] = "sentTickets";
  DashboardMenuItem["Emails"] = "emails";
  DashboardMenuItem["PushNotifications"] = "pushNotifications";
  DashboardMenuItem["Analytics"] = "analytics";
  DashboardMenuItem["Payouts"] = "payouts";
  // profile
  DashboardMenuItem["General"] = "general";
  DashboardMenuItem["Password"] = "password";
  DashboardMenuItem["Privacy"] = "privacy";
  DashboardMenuItem["OrganizerSignup"] = "organizer-signup";
  DashboardMenuItem["ApiKeys"] = "apiKeys";
  return DashboardMenuItem;
}({});
var getDefaultDashboardMenu = function getDefaultDashboardMenu() {
  return {
    state: DashboardMenuState.Dashboard,
    active: DashboardMenuItem.MyEvents,
    event: {
      name: null,
      date: null,
      time: null
    }
  };
};
var useAppStoreDefinition = defineStore('app', {
  state: function state() {
    return {
      isLoading: true,
      authDialog: false,
      dashboardMenu: getDefaultDashboardMenu(),
      sendTickets: false,
      enableGuestLogin: false,
      organizer: null,
      organizers: [],
      organizerInToken: null
    };
  },
  getters: {
    getLoading: function getLoading(state) {
      return state.isLoading;
    },
    getAuthDialog: function getAuthDialog(state) {
      return state.authDialog;
    },
    getDashboardMenu: function getDashboardMenu(state) {
      return state.dashboardMenu;
    },
    getDashboardMenuActive: function getDashboardMenuActive(state) {
      return state.dashboardMenu.active;
    },
    getOrganizer: function getOrganizer(state) {
      return state.organizer;
    },
    getOrganizers: function getOrganizers(state) {
      return state.organizers;
    },
    getEventSendTickets: function getEventSendTickets(state) {
      return state.sendTickets;
    },
    getEnableGuestLogin: function getEnableGuestLogin(state) {
      return state.enableGuestLogin;
    },
    userCanAccessDashboard: function userCanAccessDashboard(state) {
      return state.organizers.length > 0;
    },
    getOrganizerInToken: function getOrganizerInToken(state) {
      return state.organizerInToken;
    }
  },
  actions: {
    setLoading: function setLoading(payload) {
      this.isLoading = payload;
    },
    setAuthDialog: function setAuthDialog(payload) {
      this.authDialog = payload;
    },
    setDashboardMenu: function setDashboardMenu(payload) {
      this.dashboardMenu = payload;
    },
    setDashboardMenuActive: function setDashboardMenuActive(payload) {
      this.dashboardMenu.active = payload;
    },
    setOrganizer: function setOrganizer(payload) {
      this.organizer = payload;
    },
    setOrganizers: function setOrganizers(payload) {
      this.organizers = payload;
    },
    setEventSendTickets: function setEventSendTickets(payload) {
      this.sendTickets = payload;
    },
    setEnableGuestLogin: function setEnableGuestLogin(payload) {
      this.enableGuestLogin = payload;
    },
    setOrganizerInToken: function setOrganizerInToken(payload) {
      this.organizerInToken = payload;
    },
    clearAuthData: function clearAuthData() {
      this.isLoading = false;
      this.authDialog = false;
      this.dashboardMenu = getDefaultDashboardMenu();
      this.sendTickets = false;
      this.enableGuestLogin = false;
      this.organizer = null;
      this.organizers = [];
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useAppStoreDefinition directly as useAppStore
// instead.
export function useAppStore() {
  return useAppStoreDefinition(usePinia());
}
export { useAppStoreDefinition };